import { Button, Form, Input, Space, Typography } from 'antd';
import { useContext } from 'react';

import { CustomAlert } from '@app/components';
import {
  ERROR,
  ERROR_REQUIRED_FIELD,
  MIN_SIX_SYMBOLS,
  NO_SPACE,
  OFF,
  ONE_TIME_CODE,
  PATTERN_PASSWORD_VALIDATION_NO_SPACE,
} from '@app/constants';
import { LeavePageContext } from '@app/providers';

import type { NUserProfile } from '@pages/Users/UserProfile/UserProfile.types';

export const PasswordInfo: NUserProfile.PasswordInfo = ({
  setServerError,
  serverError,
  submitPasswordForm,
}) => {
  const [form] = Form.useForm<NUserProfile.PasswordFormValues>();
  const { setInputData } = useContext(LeavePageContext);

  return (
    <div>
      <Form
        form={form}
        onFinish={(values) => submitPasswordForm(values, form)}
        style={{ width: '100%' }}
        autoComplete={OFF}
      >
        <Space direction="vertical" size="large" className="form-space">
          <div className="container" style={{ gap: '10px' }}>
            <Typography.Text
              strong
              className="label-require"
              data-testid="new-password"
            >
              Новый пароль
            </Typography.Text>

            <Form.Item
              name="Password"
              className="mg-0"
              rules={[
                {
                  pattern: PATTERN_PASSWORD_VALIDATION_NO_SPACE,
                  message: <span data-testid="password-alert">{NO_SPACE}</span>,
                },
                {
                  required: true,
                  message: (
                    <span data-testid="password-alert">
                      {ERROR_REQUIRED_FIELD}
                    </span>
                  ),
                },
                {
                  min: 6,
                  message: (
                    <span data-testid="password-alert">{MIN_SIX_SYMBOLS}</span>
                  ),
                },
              ]}
            >
              <Input.Password
                data-testid="new-password-input"
                autoComplete={ONE_TIME_CODE}
                minLength={6}
                maxLength={60}
                size="large"
                onChange={(e) => {
                  setInputData({
                    event: e,
                    fieldName: 'Password',
                    isEditPage: false,
                    isTextField: true,
                  });
                }}
              />
            </Form.Item>
          </div>

          {serverError && (
            <CustomAlert
              errorType={ERROR}
              serverError={serverError}
              setServerError={setServerError}
            />
          )}

          <Button
            type="primary"
            htmlType="submit"
            className="save-button"
            data-testid="save-password"
          >
            Сохранить
          </Button>
        </Space>
      </Form>
    </div>
  );
};
